import { createAction, props } from '@ngrx/store';
import { IFolder } from 'src/app/shared/interfaces/folder/ifolder';

//padrão de nomenclatura tudo maiusculo
enum FolderActionType {
  //textos para acomparnharmos os estados de load folder
  LOAD_FOLDER = '[folder] load folder from api',
  LOAD_FOLDER_SUCCESS = '[folder] load folder from api return success',
  LOAD_FOLDER_ERROR = '[folder] load folder from api return error',
  SAVE_FOLDER = '[folder] save folder from api',
  SAVE_FOLDER_SUCCESS = '[folder] edit folder from api return success',
  EDIT_FOLDER = '[folder] edit folder from api',
  EDIT_FOLDER_SUCCESS = '[folder] edit folder from api return success',
  DELETE_FOLDER = '[folder] delete folder from api',
}
export const loadFolder = createAction(FolderActionType.LOAD_FOLDER);
export const loadFolderSuccess = createAction(
  FolderActionType.LOAD_FOLDER_SUCCESS,
  props<{ lista: IFolder[] }>()
);
//vai para o effects
export const saveFolder = createAction(
  FolderActionType.SAVE_FOLDER,
  props<{ folder: IFolder }>()
);
//vai para o reducer
export const saveFolderSuccess = createAction(
  FolderActionType.SAVE_FOLDER_SUCCESS,
  props<{ folder: IFolder }>()
);
//vai para o effects
export const editFolder = createAction(
  FolderActionType.EDIT_FOLDER,
  props<{ folder: IFolder; id: number }>()
);
//vai para o reducer
export const editFolderSuccess = createAction(
  FolderActionType.EDIT_FOLDER_SUCCESS,
  props<{ folder: IFolder }>()
);

export const deleteFolder = createAction(
  FolderActionType.DELETE_FOLDER,
  props<{ id: number }>()
);
